import NavBar from "./components/layout/Nav/NavBar";

function App() {
  return (
      <NavBar />
  );
}

export default App;
